module.exports = "https://static.wmbcdn.com/uniweb/images/4ceddd99ce62ecca2864651e8afc234a.svg";